<template>
  <div>
    <el-row style="height: 40px">
      <el-button plain type="primary" size="small" @click="gotoItem" style="margin-right: 20px; margin-left: 20px">返回商品管理</el-button>
      <el-button v-show="false" type="primary" size="small" @click="startSku">同步SKU信息</el-button>

      <el-input v-model="title" size="small" style="width: 200px"></el-input>
      <el-button type="primary" size="small"  @click="getSkuData" >搜索</el-button>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table border  style="font-size: 12px" :data="skuData" :header-cell-style="{background:'#F2F6FC',color:'#000'}" :row-class-name="tableRowClassName" :span-method="objectSpanMethod">
          <el-table-column label="主图" width="80px">
            <template slot-scope="scope" >
              <img width="60px" height="60px" :src="'https://cbu01.alicdn.com/' + scope.row.picUrl" />
            </template>
          </el-table-column>
          <el-table-column  label="商品名称" >
            <template slot-scope="scope">
              {{scope.row.title}}<a :href="'https://detail.1688.com/offer/'+scope.row.numIid + '.html'"
                                    target="_blank"
                                    class="primary">&#8194;详情</a>
            </template>
          </el-table-column>

          <el-table-column  prop="hh" label="货号" width="120px"></el-table-column>\
          <el-table-column  prop="price" label="单价" width="80px"></el-table-column>
          <el-table-column  prop="skuPropertiesName" label="颜色分类" width="240px"></el-table-column>

          <el-table-column  label="简称" >
            <template slot-scope="scope">
              <el-input type="textarea" :rows="1"  v-model="scope.row.shortName"></el-input>
            </template>
          </el-table-column>
          <el-table-column  label="成本" width="120px">
            <template slot-scope="scope">
              <el-input type="textarea" :rows="1"  v-model="scope.row.cost"></el-input>
            </template>
          </el-table-column>
          <el-table-column  label="" width="80px">
            <template slot-scope="scope">
              <el-button type="primary" size="mini"  style="display: inline" @click="updateMemo(scope.$index, scope.row)">更新</el-button>
            </template>
          </el-table-column>

        </el-table>
      </el-col>
    </el-row>

    <div class="block" align="center">
      <span class="demonstration"></span>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObject.pageCurrent"
        :page-sizes="[20, 50, 100, 500, 1000, 2000]"
        :page-size="pageObject.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageObject.rowCount">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"

    export default {
        name: "Sku",
      data(){
        return{
          title:'',
          rspan:1,
          cspan:1,
          skuData:[],
          pageObject: {
            pageCurrent: 1,
            rowCount: 0,
            pageSize: 50
          },
          timer:null,
          funName:'',
          cnName:'',
          //同步完成后提示
          msg:"",
        }
      },
      methods:{
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
          if (this.title.length == 0) {
            if ((columnIndex == 0) || ((columnIndex == 1))) {
              let rowcnt = row.rowCnt;
              let rownum = row.rowNum;

              let lpage = this.pageObject.pageCurrent;
              let lpagesize = this.pageObject.pageSize;

              let rspan = 1;
              let cspan = 1;
              //只要是第0行，不管序号是否为1
              if ((rowIndex == 0) || (rownum == 1)) {
                if (rowcnt - rownum + 1 > lpagesize - rowIndex) {
                  rspan = lpagesize - rowIndex;
                } else {
                  rspan = rowcnt - rownum + 1
                }
                //rspan = 5;
                cspan = 1;
              } else {
                rspan = 0;
                cspan = 0;
              }
              return {
                rowspan: rspan,
                colspan: cspan
              }
            }
          }
        },
        //改变pageSize
        handleSizeChange: function (val) {
          this.pageObject.pageSize = val;
          this.getSkuData();
        },
        //当前页面改变
        handleCurrentChange: function (val) {
          this.pageObject.pageCurrent = val;
          this.getSkuData();
        },
        getSkuData:function () {
          let param={
            nick: storage.get("nick"),
            title:this.title,
            pageCurrent: this.pageObject.pageCurrent,
            rowCount: this.pageObject.rowCount,
            pageSize: this.pageObject.pageSize,
          }
          $api.post("/item/getSku", param, response =>{
            let dataResult =  response.data;
            console.log(dataResult);
            if(dataResult.state == 1 && dataResult.message == "ok"){
              this.skuData = dataResult.data.sku;

              let pageObject = dataResult.data.pageObject;
              this.pageObject.rowCount = pageObject.rowCount;
              this.pageObject.pageSize = pageObject.pageSize;

            }else{

              this.$message.error(dataResult);
            }
          })
        },

        //轮询同步状态
        getStatus:function () {
          this.msg='';
          let param={
            nick:storage.get("nick"),
            subNick:storage.get("subnick"),
            funName:this.funName,
            status:"1",
          }
          $api.post("/trade/getStatus", param, response =>{
            let dataResult =  response.data;
            if(dataResult.data == "success") {
              this.getSkuData();
              clearTimeout(this.timer);
              this.$message.success("【"+this.cnName +"】数据同步完成。");
              this.msg="【"+this.cnName +"】数据同步完成。";
            }
            else {
              this.timer = setTimeout(this.getStatus, 3000);
              this.msg='running';
              this.$message.warning("【"+this.cnName +"】数据同步中.....");
            }

          })
        },

        startSku:function() {
          this.$confirm('即将开始从淘宝获取数据，是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success'
          }).then(() => {
            this.getTbSku();
          })
        },

        getTbSku :function(){
          this.funName="GetSkus";
          this.cnName=" SKU ";
          let param ={
            nick: storage.get("nick"),
            subnick: storage.get("subnick"),
            allItem:'',
          }
          $api.post("/item/getTbSku", param , response =>{
            let dataResult =  response.data;
            if(dataResult.state == 1 && dataResult.message == 'ok'){
              this.timer = setTimeout(this.getStatus, 1000);
            }else{
              this.$message.error(dataResult);
            }
          })
        },
        updateMemo:function (index, row) {
          let param ={
            nick:storage.get("nick"),
            skuId: row.skuId,
            shortName: row.shortName,
            cost:row.cost,
          };
          $api.post("/item/updateSkuShortName", param, response => {
            let dataResult = response.data;

            if (dataResult.state == 1 && dataResult.message == "ok") {
              this.$message({
                type: 'success',
                message: '恭喜，设置简称成本价成功！'
              });
            }else {
              this.$message.error(dataResult);
            }
          })
        },
        gotoItem:function(){
          this.$router.replace({name: 'Item'});
        },
      },
      mounted(){
        this.getSkuData();
      }
    }
</script>

<style >
  a{
    color: #409EFF;
    text-decoration: none;
  }

  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }

</style>



// WEBPACK FOOTER //
// src/page/Sku.vue